export default __webpack_public_path__ + "static/Senzo-c3585db1ee39fcf0276042a0f55c8081.png";